export const STRIPE_CONFIG = {
    // Replace with your actual Stripe Publishable Key
    // For development, it usually starts with 'pk_test_'
    PUBLIC_KEY: 'pk_test_PLACEHOLDER_KEY',

    // Define Price IDs for your subscriptions
    // You must create these Products/Prices in your Stripe Dashboard
    PRICES: {
        PREMIUM_MONTHLY: 'price_PLACEHOLDER_MONTHLY',
        PREMIUM_YEARLY: 'price_PLACEHOLDER_YEARLY'
    },

    // URLs for redirection
    SUCCESS_URL: `${window.location.origin}/payment/success`,
    CANCEL_URL: `${window.location.origin}/payment/cancel`,
}

export const getStripePriceId = (interval: 'month' | 'year') => {
    return interval === 'month'
        ? STRIPE_CONFIG.PRICES.PREMIUM_MONTHLY
        : STRIPE_CONFIG.PRICES.PREMIUM_YEARLY
}
